"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MorePosition = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var estate_1 = require("../../model/estate");
var service_1 = require("../../../library/base/service");
var MorePosition = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MorePosition, _super);
    function MorePosition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '位置及周边更多信息接口';
        _this.code = '101090';
        _this.desc = '位置及周边更多信息接口';
        _this.requestParams = new estate_1.MorePositionRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return MorePosition;
}(service_1.BaseService));
exports.MorePosition = MorePosition;
//# sourceMappingURL=morePosition.js.map